import ShopTeaser, { type ShopTeaserProps } from '@/components/ShopTeaser/ShopTeaser'
import ShopTeaserMulti, { type ShopMultiTeaserProps, type Offer } from '@/components/ShopTeaser/ShopTeaserMulti'
import styles from './AffiliateInline.module.scss'

// toDo: löschen?!
export type ImageData = {
  baseUrl: string
  crop: string
  filename: string
  heightRatio: number
}

export type WidgetAffiliateContext = {
  readonly items?: ReadonlyArray<{
    readonly id: string
    readonly model: {
      readonly image?: ImageData
      readonly amazonMap?: {
        image?: string
        detailPageURL?: string
        price?: string
        customerReviewsCount?: string
        customerReviewsStarRating?: string
        title?: string
        listPrice?: string
        isPrimeEligible?: string
      }
      readonly fields: {
        readonly 'shop-txt': string
        readonly 'amazon-txt'?: string
        readonly 'shop-url': string
        readonly 'shop-nofollow': string
        readonly 'shop-price': string
        readonly 'shop-price-old': string
        readonly 'amazon-ratio': string
        readonly 'shop-ratio-mobile': string
        readonly 'special-price': string
        readonly 'shop-button-text': string
        readonly 'shop-viewpixel': string
        readonly 'shop-multi'?: [
          {
            readonly value: {
              readonly seller?: {
                readonly value: string
              }
              readonly price?: {
                readonly value: string
              }
              readonly 'price-old'?: {
                readonly value: string
              }
              readonly url?: {
                readonly value: string
              }
            }
          },
        ]
      }
    }
  }>
}

export default function WidgetAffiliateInline({ item }: { readonly item: WidgetAffiliateContext }) {
  return (
    <>
      {item.items?.map((embed) => {
        let shopTeaserProps: ShopTeaserProps | undefined = undefined
        let shopMultiTeaserProps: ShopMultiTeaserProps | undefined = undefined

        if (embed.model.fields['shop-multi']) {
          const offers: Array<Offer> | undefined = []

          embed.model.fields['shop-multi'].map((offer) => {
            const seller = offer.value.seller?.value
            let url = offer.value.url?.value
            let price = offer.value.price?.value
            let listPrice = offer.value['price-old']?.value

            if (seller === 'amazon' && embed.model.amazonMap) {
              url = embed.model.amazonMap.detailPageURL
              price = embed.model.amazonMap.price
              listPrice = embed.model.amazonMap.listPrice
            }

            if (seller && url && price) {
              offers.push({
                seller: seller,
                price: price,
                listPrice: listPrice,
                url: url,
              })
            }
          })

          if (offers && offers.length > 0) {
            shopMultiTeaserProps = {
              offers: offers,
              nofollow: embed.model.fields['shop-nofollow'],
            }

            if (embed.model.amazonMap) {
              shopMultiTeaserProps.txt = embed.model.amazonMap.title
              shopMultiTeaserProps.imgSrc = embed.model.amazonMap.image
            } else {
              shopMultiTeaserProps.txt = embed.model.fields['shop-txt']
              shopMultiTeaserProps.imageData = embed.model.image
            }
          }
        } else {
          if (embed.model.amazonMap) {
            let shop_streichpreis = embed.model.amazonMap.listPrice ? embed.model.amazonMap.listPrice : undefined
            shop_streichpreis =
              embed.model.fields['special-price'] && !shop_streichpreis
                ? embed.model.amazonMap.price
                : shop_streichpreis

            shopTeaserProps = {
              url: embed.model.amazonMap.detailPageURL,
              nofollow: embed.model.fields['shop-nofollow'],
              price: embed.model.fields['special-price'] || embed.model.amazonMap.price,
              listPrice: shop_streichpreis,
              txt: embed.model.fields['amazon-txt'] || embed.model.amazonMap.title,
              reviewsCount: embed.model.amazonMap.customerReviewsCount,
              reviewsStarRating: embed.model.amazonMap.customerReviewsStarRating,
              isPrimeEligible: embed.model.amazonMap.isPrimeEligible,
              buttonTxt: 'Zum Angebot bei amazon.de',
              imgSrc: embed.model.amazonMap.image,
            }
          } else {
            shopTeaserProps = {
              url: embed.model.fields['shop-url'],
              nofollow: embed.model.fields['shop-nofollow'],
              price: embed.model.fields['shop-price'],
              listPrice: embed.model.fields['shop-price-old'],
              txt: embed.model.fields['shop-txt'],
              buttonTxt: embed.model.fields['shop-button-text'],
              imageData: embed.model.image,
            }
          }
        }

        return (
          <div key={embed.id} className={styles.wrapper}>
            {shopTeaserProps && <ShopTeaser props={shopTeaserProps} />}
            {shopMultiTeaserProps && <ShopTeaserMulti props={shopMultiTeaserProps} />}
            {embed.model.fields['shop-viewpixel'] && (
              <img width="0" height="0" src={embed.model.fields['shop-viewpixel']} alt="" />
            )}
          </div>
        )
      })}
    </>
  )
}
